"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SlackLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "logo-slack_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h48v48H0z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-slack_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.625 32.221v-4.07c-.022-.691.17-1.372.55-1.949a3.397 3.397 0 016.088.866c.097.304.145.621.142.94v8.47a3.39 3.39 0 01-6.719.575 3.842 3.842 0 01-.061-.755v-4.077z",
    fill: "#F40058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.759 31.392h-4.102a3.588 3.588 0 01-1.75-.42 3.347 3.347 0 011.039-6.255c.216-.037.436-.055.656-.055h8.4a3.36 3.36 0 01.421 6.693 4.506 4.506 0 01-.581.037h-4.083z",
    fill: "#F6B000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79 22.942h-4.133a3.371 3.371 0 01-2.475-.984 3.273 3.273 0 01-1.002-2.567 3.39 3.39 0 012.834-3.093c.264-.037.53-.056.798-.056h8.042a3.571 3.571 0 011.677.365 3.322 3.322 0 011.855 2.63 3.372 3.372 0 01-2.876 3.711 3.407 3.407 0 01-.501 0l-4.22-.006z",
    fill: "#00C7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.168 15.376v-4.182a3.378 3.378 0 016.663-.78c.057.267.086.538.087.81v8.29a3.378 3.378 0 01-6.7.62 4.19 4.19 0 01-.056-.62l.006-4.138z",
    fill: "#00BA78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.936 26.499v1.479a3.385 3.385 0 11-4.158-3.23 3.33 3.33 0 01.743-.086h3.198c.217 0 .217 0 .217.216V26.5z",
    fill: "#F40058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.168 34.906v-1.651c0-.13.031-.18.167-.18h3.322a3.36 3.36 0 11-3.452 3.712c-.062-.618 0-1.237 0-1.9l-.037.02z",
    fill: "#F6B000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.549 14.516h-1.485a3.353 3.353 0 01-.977-6.576 3.285 3.285 0 013.285.81 3.236 3.236 0 011.033 2.394v3.174c0 .198 0 .198-.204.198h-1.652z",
    fill: "#00C7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.506 22.936h-1.714c-.136 0-.173-.044-.173-.174v-3.241a3.37 3.37 0 015.777-2.325 3.371 3.371 0 01-2.43 5.733c-.483.013-.972.007-1.46.007z",
    fill: "#00BA78"
  })));
}
var _default = SlackLogo;
exports.default = _default;